/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TrainRequestBuilderRequestsMetadata, type TrainRequestBuilder } from './train/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/models/sku
 */
export interface SkuRequestBuilder extends BaseRequestBuilder<SkuRequestBuilder> {
    /**
     * The train property
     */
    get train(): TrainRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SkuRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/models/sku";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SkuRequestBuilderNavigationMetadata: Record<Exclude<keyof SkuRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    train: {
        requestsMetadata: TrainRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
